import React from "react";

export const ScreenContext = React.createContext<{
  setProductDescription: (description: string) => void;
}>({
  setProductDescription: () => {},
});
